export default "__VITE_ASSET__dde0f1d5__"